import { cva } from 'class-variance-authority';

export const cvaOwnBlock = cva(
  [
    'OwnBlockStyles-cvaOwnBlock',
    'relative',
    'flex-1',
    'bg-cDarkGray rounded-[0.8rem]',
  ],
  {
    variants: {
      shadow: {
        true: ['shadow-custom'],
      },
      default: {
        true: ['bg-transparent'],
      },
    },
  }
);

export const cvaOwnBlockInner = cva(['OwnBlockStyles-cvaOwnBlockInner'], {
  variants: {
    size: {
      own: ['px-1.4 py-1.6'],
      secondary: ['px-1.6 py-1.2'],
      third: ['px-1.6'],
      big: ['px-2.4 py-2'],
      default: [''],
    },
  },
});
